import { MenuItem, Select } from '@mui/material';
import React from 'react';

const CenterSelect = ({
    centers,
    selectedCenter,
    setSelectedCenter,
}: {
    centers: string[];
    selectedCenter: string | undefined;
    setSelectedCenter: (center: string) => void;
}) => {
    if (centers.length === 0) {
        return <></>;
    }
    return (
        <Select
            value={selectedCenter}
            onChange={(e) => {
                setSelectedCenter(e.target.value);
            }}
            style={{ height: 40, marginBottom: 20, marginTop: 20, width: 300 }}
            MenuProps={{
                MenuListProps: {
                    sx: {
                        'li.MuiButtonBase-root': {
                            display: 'flex',
                            flexDirection: 'column',
                        },
                    },
                },
            }}
        >
            {centers.map((it, i) => (
                <MenuItem key={i} value={it}>
                    {it}
                </MenuItem>
            ))}
        </Select>
    );
};

export default CenterSelect;
